import { OutputWidgetSelection } from 'services/device/presentation/ui/widget/widget-renderer/OutputWidgetSelection';

export class SummaryWidgetSelection extends OutputWidgetSelection {
}
